import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { PHONE } from 'constants/formFields';
import { verificationPhoneSchema } from 'utils/validators';

import type { IUseSetupPhoneModalForm } from '../interfaces/IUseSetupPhoneModalForm';
import type { TSetupPhoneModalForm } from '../interfaces/TSetupPhoneModalForm';

const useSetupPhoneModalForm = ({ parsedCountry }: IUseSetupPhoneModalForm) => {
  const {
    control,
    handleSubmit,
    formState,
    setError,
  } = useForm<TSetupPhoneModalForm>({
    mode: 'onSubmit',
    resolver: yupResolver(verificationPhoneSchema({ parsedCountry })),
    defaultValues: {
      [PHONE]: '',
    },
  });
  const { isValid } = formState;

  return {
    control,
    handleSubmit,
    isValid,
    setError,
  };
};

export default useSetupPhoneModalForm;
